import { Card, Stack, Text, Title } from '@mantine/core';
import { useAuth } from '../auth/AuthProvider';

/**
 * Parent / student kezdőlap placeholder.
 * Itt lesznek majd a saját gyermek(ek) előírásai, befizetés-történet, elszámolások.
 */
export function ParentDashboardPlaceholder() {
  const { user, activeRole } = useAuth();
  return (
    <Stack gap="md">
      <Title order={2}>Üdv, {user?.displayName ?? 'felhasználó'}!</Title>
      <Text size="sm" c="dimmed">
        Aktív szerep: <strong>{activeRole}</strong>
      </Text>
      <Card withBorder padding="md">
        <Text>
          Itt jelennek majd meg a gyermek(ek) előírásai, befizetés-történet, elszámolás.
        </Text>
      </Card>
    </Stack>
  );
}
